import Api, {
  baseURL,
  requestOptionsDELETE,
  requestOptionsGET,
  requestOptionsPOST,
  requestOptionsPUT,
  requestOptionsPUTWithBody
} from '../api';
import newFetch from '../utils/newFetch';

const state = {
  users: [],
  roles: [],
  paginate: {
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0
  }
};

const getters = {
  getUsers: (state) => state.users,
  getRoles: (state) => state.roles,
  getPaginate: ({ paginate }) => {
    return `?PageSize=${paginate.pageSize}&PageNumber=${paginate.pageNumber}`;
  }
};

const mutations = {
  setUsers(state, payload) {
    state.users = payload;
  },
  setRoles(state, payload) {
    state.roles = payload;
  },
  setItemPerPage(state, payload) {
    state.paginate.pageSize = payload;
  },
  setPageNumber(state, payload) {
    state.paginate.pageNumber = payload;
  },
  setTotalPages(state, payload) {
    state.paginate.totalPages = payload;
  },
  setTotalRecords(state, payload) {
    state.paginate.totalRecords = payload;
  },
  toggleDisableUser(state, payload) {
    state.users[payload.index].disabled = !payload.disabled;
  },
  trashUser(state, payload) {
    state.users = state.users.filter(({ id }) => id !== payload);
  }
};

const actions = {
  async fetchUsers(context) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getUsers + context.getters.getPaginate,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data, totalPages, totalRecords }) => {
          context.commit('setUsers', data);

          context.commit('setTotalPages', totalPages);
          context.commit('setTotalRecords', totalRecords);
          resolve(data);
        })
        .catch((data) => reject(data));
    });
  },
  fetchListUsers() {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getListBackOfficeUsers, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  fetchUser(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getUsers + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchRoles(context) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getRoles, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          context.commit('setRoles', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createUser(_, body) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.createUsers, requestOptionsPOST(localStorage.getItem('accessToken'), body))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  editUser(_, body) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.createUsers, requestOptionsPUTWithBody(localStorage.getItem('accessToken'), body))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deleteUser(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getUsers + id, requestOptionsDELETE(localStorage.getItem('accessToken')))
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  toggleUser(_, item) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + (!item.disabled ? Api.disableUser : Api.enableUser) + item.id,
        requestOptionsPUT(localStorage.getItem('accessToken'))
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
